import { IAccordionImage } from '@seb/web-design-system/accordion-group-image';

export const accordionImageSkeleton: IAccordionImage = { media: {} };
